// Button component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import IntlUtil from '../../../lib/intlutil.jsx'
import IntlMessage from '../intl/intl_message.jsx'

class Button extends Component {
  static get propTypes () {
    return {
      title: PropTypes.string,
      type: PropTypes.string,
      secondary: PropTypes.bool,
      enabled: PropTypes.bool,
      onClick: PropTypes.func,
      className: PropTypes.string,
      icon: PropTypes.string,
      canHover: PropTypes.bool,
      tooltip: PropTypes.string,
      tooltipPosition: PropTypes.oneOf(['right', 'left', 'bottom', 'top'])
    }
  }

  static get defaultProps () {
    return {
      secondary: false,
      enabled: true,
      onClick: null,
      className: null,
      icon: null,
      canHover: true,
      tooltip: '',
      tooltipPosition: 'right'
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      tooltipStyle: null,
      tipClassName: ''
    }

    this._intializeTooltip = false
    this._references = {
      button: React.createRef(),
      tooltip: React.createRef()
    }
  }

  componentDidMount () {
    if (this._references.tooltip.current) {
      this._updateTooltipPositions()
    }
  }

  _updateTooltipPositions () {
    if (!this._intializeTooltip) {
      this._updateTooltipStyle()
      this._intializeTooltip = true
    }
  }

  render () {
    const { tooltip, tooltipPosition } = this.props

    let tooltipPositionClass = ''
    if (tooltipPosition === 'left') {
      tooltipPositionClass = 'tipleft'
    } else if (tooltipPosition === 'right') {
      tooltipPositionClass = 'tipright'
    } else if (tooltipPosition === 'top') {
      tooltipPositionClass = 'tiptop'
    } else if (tooltipPosition === 'bottom') {
      tooltipPositionClass = 'tipbottom'
    }

    const classes = classnames(
      'button',
      {
        button__secondary: this.props.secondary
      },
      this.props.className,
      tooltipPositionClass
    )
    const tooltipStyle = this.state.tooltipStyle
    const tipClassName = this.state.tipClassName
    const titleConvert = this.props.title
      ? IntlUtil.convertMessage(this.props.title)
      : ''

    return (
      <button
        className={classes}
        ref={this._references.button}
        type={this.props.type}
        title={titleConvert}
        onClick={this.props.onClick}
        disabled={!this.props.enabled}
        onMouseEnter={this._onMouseEnter.bind(this)}
      >
        {this._renderIcon()}
        {tooltip ? (
          <span
            key='tooltip'
            ref={this._references.tooltip}
            className='tooltip tooltip_hidden'
            style={tooltipStyle}
          >
            <IntlMessage ident={tooltip} />
            <span
              className={`tip${tipClassName ? ' ' + tipClassName : ''}`}
            />
          </span>
        ) : null}
        {tooltip ? (
          <span key='tooltiphover' className='tooltip' style={tooltipStyle}>
            <IntlMessage ident={tooltip} />
            <span
              className={`tip${tipClassName ? ' ' + tipClassName : ''}`}
            />
          </span>
        ) : null}
        <span className='text'>{titleConvert}</span>
      </button>
    )
  }

  /* Private functions */
  _renderIcon () {
    if (this.props.icon) {
      const iconClass = `icon-${this.props.icon} normal`
      const iconHoverClass = `icon-${this.props.icon}-hover hover`

      return (
        <span className='icon'>
          <i className={iconClass} />
          {this.props.canHover ? <i className={iconHoverClass} /> : null}
        </span>
      )
    }

    return null
  }

  _onMouseEnter () {
    this._updateTooltipStyle()
  }

  _updateTooltipStyle () {
    if (this._references.tooltip.current) {
      const tooltipPosition = this.props.tooltipPosition
      const {
        height,
        width
      } = this._references.tooltip.current.getBoundingClientRect()
      const {
        width: buttonWidth,
        height: buttonHeight,
        left: buttonLeft
      } = this._references.button.current.getBoundingClientRect()
      const { innerWidth: windowWidth } = window
      const tooltipOffsetX = buttonLeft + buttonWidth + width
      let tooltipStyle = null
      let tipClassName = ''

      if (tooltipPosition === 'left') {
        tooltipStyle = {
          right: '100%',
          left: 'auto',
          top: (buttonHeight - height) / 2
        }
      } else if (tooltipPosition === 'right') {
        tooltipStyle = {
          left: '100%',
          right: 'auto',
          top: (buttonHeight - height) / 2
        }
      } else if (tooltipPosition === 'top') {
        tooltipStyle = {
          bottom: '100%',
          top: 'auto',
          left: (buttonWidth - width) / 2
        }

        if (tooltipOffsetX > windowWidth) {
          tooltipStyle.left = 'auto'
          tooltipStyle.right = 0

          tipClassName = 'right'
        }
      } else if (tooltipPosition === 'bottom') {
        tooltipStyle = {
          top: '100%',
          bottom: 'auto',
          left: (buttonWidth - width) / 2
        }

        if (tooltipOffsetX > windowWidth) {
          tooltipStyle.left = 'auto'
          tooltipStyle.right = 0

          tipClassName = 'right'
        }
      }

      this.setState({ tooltipStyle: tooltipStyle, tipClassName })
    }
  }
}

export default Button
